import { useSelector, useDispatch } from "react-redux";
import { lazy, Suspense, useEffect, useState, useContext } from "react";
import { getPlayerProfileDetail } from "../store/actions";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import Search from "../components/games/search/Search";
import Balance from "../components/Balance/Balance";
import { CSS_CLASSES } from "../css-classes";
import SliderSec from "../components/slider/SliderSec";
import ErrorBoundary from '../helpers/ExceptionHandler/componentException';
import { ThemeModeContext } from "../components/ThemeMode/Context";

// Lazy load components
const Jackpot = lazy(() => import("../components/commonSection/Jackpot/Jackpot"));
const GameCategoryCarousel = lazy(() => import("../components/games/game-category/gamecategorycarousel/GameCategoryCarousel"));
const GameProviderGrid = lazy(() => import("../components/games/game-category/game-category-ver-menu/game-provider/gameprovidergrid/GameProviderGrid"));
const GameCategoryGridMenu = lazy(() => import("../components/games/game-category/game-category-grid-menu/GameCategoryGridMenu"));
const GameProviderCarousel = lazy(() => import("../components/games/game-category/game-category-ver-menu/game-provider/gameprovidercarousel/GameProviderCarousel"));
const HotGamesCarousel = lazy(() => import("../components/games/game-category/hot-games/hotgamescarousel/HotGamesCarousel"));
const NewGamesCarousel = lazy(() => import("../components/newgames/NewGamesCarousel"));
const LotteryFullBoxSlider = lazy(() => import("../components/games/lottery-results/lottery-full-box-slider/LotteryFullBoxSlider"));
const LotteryGrid = lazy(() => import("../components/games/lottery-results/lotterygrid/LotteryGrid"));
const Readmore = lazy(() => import("../components/commonSection/readmore/Readmore"));
const PaymentGrid = lazy(() => import("../components/commonSection/payment/payment-grid/PaymentGrid"));
const Partners = lazy(() => import("../components/commonSection/partners/Partners"));
const FloatingComponents = lazy(() => import("../components/floatingComponents/FloatingComponents"));
// const SliderSec = lazy(() => import("../components/slider/SliderSec"));
const FallbackLoader = () => <></>

const Home = () => {
  useEffect(() => {
  }, []);
  const initAssetConfig = {
    width: "300px",
    height: "200px",
    alt: "defautl alt",
    description: "default description",
    image: "",
    link: window.location.origin,
  };
  const initStyle = {
    width: "",
    height: "",
    backgroundImage: "",
  };

  // Set & get state
  const [style, setStyle] = useState(initStyle);
  const [assets, setAssets] = useState(initAssetConfig);
  const loggedIn = window.localStorage.getItem("user_token");

  const deviceType = localStorage.getItem('device_type');
  const dispatch = useDispatch();
  const location = useLocation();
  const { themeMode } = useContext(ThemeModeContext);


  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated || false);


  // Fetch other media
  const { otherMedia, componentSetting } = useSelector((state) => ({
    otherMedia: state.othermediaInformationListR.data,
    componentSetting: state.componentSettingListR.data
  }));

  const footerBanner = otherMedia?.footer_banner?.[0];

  useEffect(() => {
    if (loggedIn != null && loggedIn !== "") dispatch(getPlayerProfileDetail());
  }, [loggedIn, dispatch]);

  useEffect(() => {
    setAssets(initAssetConfig);
    setStyle(initStyle);

    const background = otherMedia[`background`];
    if (background) {
      const updatedAssets = { ...assets };
      const updatedStyle = { ...style };
      
      // Update width if defined
      if (background.width) {
        updatedAssets.width = background.width;
        updatedStyle.width = `${background.width}px`;
      }
      // Update height if defined
      if (background.height) {
        updatedAssets.height = background.height;
        updatedStyle.height = `${background.height}px`;
      }

      if (background.description) {
        updatedAssets.description = background.description;
      }

      if (background.alternate) {
        updatedAssets.alt = background.alternate;
      }

      if (background.path) {
        updatedAssets.image = background.path;
        updatedStyle.backgroundImage = `url(${background.path})`;
      }

      if (background.link) {
        updatedAssets.link = background.link;
      }
      // Batch set state updates
      setAssets(updatedAssets);
      setStyle(updatedStyle);
    }
  }, [otherMedia, deviceType]);

 // Memoize path checks to avoid re-evaluation
  const isPaymentVisible = useMemo(() => {
    const { custom_loading, "device-login-info": deviceLoginInfo } = componentSetting || {};
    return (
      custom_loading?.options?.common_section_handle &&
      deviceLoginInfo?.options?.payments &&
      ["/", "/deposit", "/withdraw", "/transaction-queue"].includes(location.pathname)
    );
  }, [componentSetting, location.pathname]);

  const isReadmoreVisible = useMemo(() => {
    const readMore = componentSetting?.["read-more"];
    return readMore && location.pathname === "/" && readMore["default-value"] === "fixed";
  }, [componentSetting, location.pathname]);

  const isPartnersVisible = useMemo(() => {
    const partnersLogo = componentSetting?.["partners-logo"];
    return partnersLogo && partnersLogo["default-value"];
  }, [componentSetting]);

  const renderFooterBanner = () => {
    const image = <img src={footerBanner.path} alt={footerBanner.alternate || 'Footer Banner'} className="footer-banner-img" style={{}} />;
    return image;
  }

  return (
    <>
      <div className="myBody">
        <div className="header-slider-section background-slider_section">
          <SliderSec isAuthenticated={isAuthenticated} />
        </div>
        <Suspense fallback={<FallbackLoader />}>
          <div
            className={CSS_CLASSES.gamesMain}
            style={
              style["backgroundImage"] !== ""
                ? {
                  backgroundImage: style["backgroundImage"],
                  width: style["width"],
                  height: style["height"],
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }
                : {}
            }
          ></div>
          {
            // Mobile device
            deviceType === 'mobile' &&
            <>
              {loggedIn && <Balance />}
              <div className="skeleton-search">
                <ErrorBoundary>
                  <Search />
                </ErrorBoundary>
              </div>
              <div className="skeleton-game-category">
                <ErrorBoundary>
                  <GameCategoryGridMenu />
                </ErrorBoundary>
              </div>
              <div className="skeleton-lottery">
                <ErrorBoundary>
                  <LotteryGrid />
                </ErrorBoundary>
              </div>
              {/* <div className="skeleton-jackpot">
                <Jackpot />
              </div> */}
              <div className="skeleton-game-provider">
                <ErrorBoundary>
                  <GameProviderGrid />
                </ErrorBoundary>
              </div>
              <div className={CSS_CLASSES.commonSec}>
                <div className="game-outer">
                  <div className="skeleton-readmore">
                    {isReadmoreVisible && <ErrorBoundary><Readmore /></ErrorBoundary>}
                  </div>
                  <div className="skeleton-payment">
                      {footerBanner && footerBanner.path && (
                        <ErrorBoundary>
                          <div 
                          className="footer-banner-container-mobile background-footer container pt-1 pb-1 pb-md-0 pt-md-3" 
                          >
                            {renderFooterBanner()}
                          </div>
                        </ErrorBoundary>
                      )}
                    {isPaymentVisible && <ErrorBoundary><PaymentGrid /></ErrorBoundary>}
                  </div>
                </div>
              </div>
            </>
          }

          {
            // Desktop device
            deviceType === 'desktop' &&
            <>
              <ErrorBoundary>
                <GameProviderCarousel />
              </ErrorBoundary>
              <ErrorBoundary>
                <GameCategoryCarousel />
              </ErrorBoundary>
              <div className="hot-new-game-cm background-hot_new_section">
                <div className="container">
                  <Search />
                  <div className="hot-new-game-wrapper">
                    <div className="hot-new-game">
                      <ErrorBoundary>
                        <HotGamesCarousel />
                      </ErrorBoundary>
                      <ErrorBoundary>
                        <NewGamesCarousel />
                      </ErrorBoundary>
                    </div>
                    <div className="cm-jackpot">
                      <ErrorBoundary>
                        <Jackpot />
                      </ErrorBoundary>
                    </div>
                  </div>
                </div>
              </div>
              <ErrorBoundary>
                <LotteryFullBoxSlider />
              </ErrorBoundary>
              <div className={CSS_CLASSES.commonSec}>
                <div className="game-outer">
                  {isReadmoreVisible && <ErrorBoundary><Readmore /></ErrorBoundary>}
                  {footerBanner && footerBanner.path && (
                    <ErrorBoundary>
                      <div
                        className="footer-banner-container background-footer container pt-1 pb-1 pb-md-5 pt-md-5"
                      >
                        {renderFooterBanner()}
                      </div>
                    </ErrorBoundary>
                  )}
                  {isPartnersVisible && <ErrorBoundary><Partners /></ErrorBoundary>}
                </div>
              </div>
            </>
          }
          {typeof componentSetting?.["floating-components"] !== "undefined" &&
            componentSetting?.["floating-components"]?.["default-value"] && (
              <ErrorBoundary>
                <FloatingComponents />
              </ErrorBoundary>
            )}
        </Suspense>
      </div>
    </>
  );
};

export default Home;
